import { ClickEvent } from "@mcleod/components";
import { Navigation } from "@mcleod/core";
import { AutogenLayoutTariffQuickInfo } from "./autogen/AutogenLayoutTariffQuickInfo";

export class TariffQuickInfo extends AutogenLayoutTariffQuickInfo {

    imageRedirectToTariffManagementOnClick(event: ClickEvent) {
        const tariffUniqueId = this.activeRow.get("tar_uid");
        Navigation.navigateTo("lme/dispatch/TariffManagement?mode=update&key=" + tariffUniqueId, {newTab: true});
    }
}
